<template>
    <section class="profile">
        <header class="profile__header">
            <h1>Смена пароля</h1>
            <p>
                <a href="/profile" class="profile__back">← Назад к профилю</a>
            </p>
        </header>

        <section class="profile__card profile__card--form">
            <form class="profile__form" @submit.prevent="submit">
                <div class="profile__form-group">
                    <label class="profile__label" for="current_password">Текущий пароль</label>
                    <input
                        id="current_password"
                        v-model="form.current_password"
                        type="password"
                        class="profile__input"
                        autocomplete="current-password"
                        required
                    />
                    <p v-if="errors.current_password" class="profile__error">{{ errors.current_password }}</p>
                </div>

                <div class="profile__form-group">
                    <label class="profile__label" for="password">Новый пароль</label>
                    <input
                        id="password"
                        v-model="form.password"
                        type="password"
                        class="profile__input"
                        autocomplete="new-password"
                        minlength="8"
                        required
                    />
                    <p v-if="errors.password" class="profile__error">{{ errors.password }}</p>
                </div>

                <div class="profile__form-group">
                    <label class="profile__label" for="password_confirmation">Подтверждение пароля</label>
                    <input
                        id="password_confirmation"
                        v-model="form.password_confirmation"
                        type="password"
                        class="profile__input"
                        autocomplete="new-password"
                        minlength="8"
                        required
                    />
                    <p v-if="errors.password_confirmation" class="profile__error">{{ errors.password_confirmation }}</p>
                </div>

                <p v-if="formError" class="profile__error">{{ formError }}</p>
                <p v-if="successMessage" class="profile__success">{{ successMessage }}</p>

                <div class="profile__form-actions">
                    <button type="submit" class="profile__btn" :disabled="isLoading">
                        {{ isLoading ? 'Сохранение…' : 'Сохранить' }}
                    </button>
                </div>
            </form>
        </section>
    </section>
</template>

<script>
export default {
    name: 'ChangePassword',
    props: {
        userData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            form: {
                current_password: '',
                password: '',
                password_confirmation: '',
            },
            errors: {},
            formError: '',
            successMessage: '',
            isLoading: false,
            csrf: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        };
    },
    methods: {
        async submit() {
            this.isLoading = true;
            this.errors = {};
            this.formError = '';
            this.successMessage = '';

            try {
                const response = await fetch('/profile/password', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'X-CSRF-TOKEN': this.csrf,
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify(this.form),
                });

                const data = await response.json().catch(() => ({}));

                if (response.status === 422) {
                    const bag = data.errors || {};
                    const mapped = {};
                    Object.keys(bag).forEach((key) => {
                        mapped[key] = Array.isArray(bag[key]) ? bag[key][0] : bag[key];
                    });
                    this.errors = mapped;
                    return;
                }

                if (!response.ok) {
                    this.formError = data.message || 'Не удалось сменить пароль';
                    return;
                }

                this.successMessage = data.message || 'Пароль обновлён';
                window.location.href = data.redirect_url || '/profile';
            } catch (error) {
                this.formError = 'Ошибка сети. Попробуйте ещё раз.';
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
